export default "__VITE_ASSET__DCJsFV_z__"